import splash from "./splash";

export * from "./splash";

export default splash;
